$(document).on('click', '.tablinks', function () {
  var $this = $(this);
  var cityName = $this.data('city');
  var $section = $this.closest('.tab-section');

  // Hide all tab content and remove active class in the current section
  $section.find('.tabcontent').hide().removeClass('active');
  $section.find('.tablinks').removeClass('active');

  // Show the current tab content and set active class
  $section.find('#' + cityName).show().addClass('active');
  $this.addClass('active');
});

$(window).on('load', function() {
    console.log("Page fully loaded");

    function filterImages(selectedVal) {
        var altTagMatched = false;

        $(".custom__product-variant").each(function() {
            var img_alt = $(this).find("img").attr('alt') || "";
            var lastValue = img_alt.split('_').pop();

            if (lastValue === selectedVal) {
                $(this).show();
                altTagMatched = true;
            } else {
                $(this).hide();
            }
        });

        $(".product-gallery__thumbnail").each(function() {
            var thumb_img = $(this).find("img").attr('alt') || "";
            var lastthumbValue = thumb_img.split('_').pop();

            if (lastthumbValue === selectedVal) {
                $(this).show();
                altTagMatched = true;
            } else {
                $(this).hide();
            }
        });

        if (!altTagMatched) {
            $(".custom__product-variant").show();
            $(".product-gallery__thumbnail").show();
        }
    }

    // Check if elements exist
    console.log("Variants count:", $(".custom__variants").length);
    console.log("Product images count:", $(".custom__product-variant").length);
    console.log("Thumbnails count:", $(".product-gallery__thumbnail").length);

    // Initial setup
    var input_val = $("input.custom__variants:checked").val();
    console.log("Initial selected value:", input_val);
    if (input_val) {
        filterImages(input_val);
    } else {
        $(".custom__product-variant").show();
        $(".product-gallery__thumbnail").show();
    }

    // Event delegation to ensure it works even if elements are loaded dynamically
    $(document).on('click', '.custom__variants', function() {
        console.log('Variant clicked');
        var selectedVal = $(this).val();
        console.log('Selected value:', selectedVal);
        filterImages(selectedVal);
    });

});
